<div class="container-fluid">
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <div class="page-title-right">
              <a style="cursor: pointer;" class="btn btn-primary" (click)="volver()">
                  Volver
              </a>
            </div>
            <h3 class="page-title">Programacion Docente | {{user.nombre_estado}}</h3>
            <hr>
            <br>
            <h4>Año {{year}}</h4>
        </div>
    </div>
  </div>
  <!-- end page title alt- 248

    <hr style="border: 2px solid black; opacity: 1">
  -->



  <!--MODULO DE PROGRAMACION DOCENTE-->

  <div class="card mt-3">
    <div class="card-header text-center">
      <div class="row">
        <div class="col-md-2">
          <h5 class="text-dark">Cupo</h5>
          <label class="form-label">{{cupo_org}}</label>
        </div>
        <div class="col-md-3">
          <h5 class="text-dark">Tipo de Formación</h5>
          <label class="form-label">Ocupación</label>
        </div>
        <div class="col-md-3">
          <h5 class="text-dark">SubTipo de Formación</h5>
          <label class="form-label">Genérico</label>
        </div>
        <div class="col-md-4">
          <h5 class="text-dark">Programa de Formación</h5>
          <label class="form-label">Programa Nacional de Aprendizaje</label>
        </div>
      </div>
    </div>
    <div class="card-body">

      <form [formGroup]="formularioProgramacion" id="formularioProgramacion">

        <div class="row g-3" >
          <div class="col-md-12">
            <label class="form-label">Alternativa de Cumplimiento</label>
            <select class="form-select" id="id_alternativa_cumplimiento" name="id_alternativa_cumplimiento" formControlName="id_alternativa_cumplimiento" required>
              <option value="" selected>--Seleccione Alternativa--</option>
              <option *ngFor="let al of alternativa" [value]="al.id_alternativa_cumplimiento">{{al.nombre}}</option>
            </select>
          </div>
          <div class="col-md-6" [style.display]="'none'">
            <label class="form-label">Espacio de Formación de la Accion Formativa </label>
            <select class="form-group form-select" name="espacio_formacion" id="espacio_formacion" (change)="select_espacio();" formControlName="espacio_formacion">
              <option value="" selected>--Seleccione Espacio de Formación--</option>
              <option *ngFor="let espacio of espaciosList" [value]="espacio">{{espacio}}</option>
            </select>
          </div>
          <div class="col-md-12" *ngIf="espacio" [style.display]="'none'">
            <label class="form-label">Otro Espacio</label>
            <input type="text" class="form-control" name="otro_espacio" id="otro_espacio" placeholder="Otro Espacio" formControlName="otro_espacio">
          </div>
          <hr style="border: 1px solid black; opacity: 0.5" class="mt-4 mb-4">
        </div>


        <div class="row g-3">
          <div class="col-md-3">
            <label for="inputPassword4" class="form-label">Ocupación Cualificada</label>
            <select class="form-select" name="id_ocupacion" id="id_ocupacion" (change)="datos_ocupacion($event)" formControlName="id_ocupacion" required>
              <option value="" selected>--Seleccione la Ocupación Cualificada--</option>
              <option *ngFor="let op of ocupaciones;" [value]="op.id_ocupacion">{{op.nombre}}</option>
            </select>
          </div>
          <div class="col-md-3 text-center">
            <label for="inputAddress" class="form-label">Código de O.C</label>
            <h6>{{filtroOcupa == undefined ? '' : filtroOcupa[0].codigo_of}}</h6>
          </div>
          <div class="col-md-3 text-center">
            <label for="inputAddress" class="form-label">Horas</label>
            <h6>{{filtroOcupa == undefined ? '' : filtroOcupa[0].horas}}</h6>
          </div>
          <div class="col-md-3 text-center">
            <label for="inputPassword4" class="form-label">Motor Productivo</label>
            <h6>{{filtroOcupa == undefined ? '' : filtroOcupa[0].motores}}</h6>
          </div>
        </div>

        <hr style="border: 1px solid black; opacity: 0.5" class="mt-4 mb-4">

        <div class="row" *ngIf="perfiles.length > 0">
          <div class="col-md-12 text-center">
            <h4>Lista de Perfiles</h4>
          </div>
        </div>

        <div class="accordion accordion-flush" id="acc_perfil" formArrayName="datosUC">
          <div *ngFor="let ppl of perfiles; let i = index" class="accordion-item" [formGroupName]="i">
            <div class="accordion-item">
              <h2 class="accordion-header text-center" id="head{{ppl.key}}">
                <button class="accordion-button {{ppl.key != '180' ? 'collapsed' : ''}} {{ppl.key == '180' ? 'text-light' : ''}}"
                  [ngClass]="ppl.key == '180' ? 'color-primary' : 'bg-light'"
                  type="button"
                  attr.data-bs-toggle="{{!valida ? 'collapse' : ''}}"
                  attr.data-bs-target="#{{ppl.key}}"
                  attr.aria-expanded="{{ppl.key == '180' ? true : false}}"
                  attr.aria-controls="{{ppl.key}}" (click)="ppl.key != '180' ? mensaje_validador() : '' ">
                  ({{ppl.value[0].ppl_codigo_of}}) - {{ppl.value[0].nombre}} - (HORAS: {{ppl.value[0].ppl_horas}})
                </button>
              </h2>
              <div id="{{ppl.key}}" class="accordion-collapse collapse {{ppl.key == '180' ? 'show' : ''}} container-fluid" attr.aria-labelledby="head{{ppl.key}}" data-bs-parent="#acc_perfil">
                <div class="row g-3" *ngIf="ppl.key == '180'" >
                  <div class="col-md-12">
                    <h5 class="mt-3 mb-3 text-danger text-center">
                      Debe llenar de manera obligatoria el ciclo formativo Inicial
                    </h5>
                  </div>
                </div>
                <div formArrayName="unidadesCurriculares">
                  <div *ngFor="let uc of ppl.value; let j = index" [formGroupName]="j">
                    <div class="row g-3">
                      <div class="col-md-12">
                        <h6 class="mt-3 mb-3 text-center">
                          <span>{{j+1}}</span> - {{uc.nombre_oferta}}
                          <span style="color: #005676;">CODIGO OF:</span> {{uc.codigo_of}}
                          <span style="color: #005676;">HORAS:</span> {{uc.horas}}
                        </h6>
                      </div>
                    </div>
                    <ng-content *ngIf="!uc.esDuplicado">
                      <div class="row g-3">
                        <div class="col-md-2 text-center">
                          <label for="inputPassword4" class="form-label">Turno</label>
                          <select class="form-select" id="id_turno" name="id_turno" formControlName="id_turno">
                            <option *ngFor="let tr of turno;" [value]="tr.id_turno">{{tr.nombre}}</option>
                          </select>
                        </div>
                        <div class="col-md-2 text-center">
                          <label for="inputAddress" class="form-label">Fecha Inicio</label>
                          <div class="input-group">
                            <input class="form-control" placeholder="Fecha Inicio" [readOnly]="true" ngbDatepicker #inicio="ngbDatepicker" formControlName="fecha_inicio">
                            <button class="btn btn-outline-secondary bi bi-calendar3 calendar" (click)="inicio.toggle()" type="button"></button>
                          </div>
                        </div>
                        <div class="col-md-2 text-center">
                          <label for="inputAddress" class="form-label">Fecha Culminación</label>
                          <div class="input-group">
                            <input class="form-control" placeholder="Fecha Culminación" [readOnly]="true" #fin="ngbDatepicker" ngbDatepicker formControlName="fecha_culminacion">
                            <button class="btn btn-outline-secondary bi bi-calendar3 calendar" (click)="fin.toggle()" type="button"></button>
                          </div>
                        </div>
                        <div class="col-md-3 text-center">
                          <label for="inputPassword4" class="form-label">Tipo Formador</label>
                          <select class="form-select" id="id_tipo_formador" name="id_tipo_formador" formControlName="id_tipo_formador" (change)="getFormador(i,j)">
                            <option value="">--Seleccione--</option>
                            <option *ngFor="let tp of tipo_formador;" [value]="tp.id_tipo_formador">{{tp.nombre}}</option>
                          </select>
                        </div>
                        <div class="col-md-3 text-center">
                          <label for="inputPassword4" class="form-label">Formador</label>
                          <select class="form-select" id="id_formador" name="id_formador" formControlName="id_formador" (change)="verificador()">
                            <option value="">--Seleccione--</option>
                            <option *ngFor="let fr of listarUnidadFormador[j];" [value]="fr.id_institucional">{{fr.nombre}}</option>
                          </select>
                        </div>
                      </div>
                    </ng-content>
                    <hr style="border: 1px solid #005676; opacity: 0.5" class="mt-4 mb-4">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4" *ngIf="perfiles.length > 0">
          <!--button type="submit" class="btn btn-lg btn-primary" (click)="cargar()">Aceptar</button-->
          <a style="cursor: pointer;" class="btn btn-lg btn-primary" (click)="cargar()">Aceptar</a>
        </div>

      </form>







    </div>
  </div>



</div>


<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>




